import { T } from "../../app/tokens.js";

export const TIMELINE_BAR_PHASES = [
  {
    key: "decide",
    label: "Decide now",
    detail: "Within 90 days of the notice or expiry date",
    color: T.leaseActionBuckets["decide-now"].foreground,
    offsetLo: 90,
    offsetHi: 0,
  },
  {
    key: "negotiate",
    label: "Negotiate",
    detail: "3-12 months before the notice or expiry date",
    color: T.leaseActionBuckets.negotiate.foreground,
    offsetLo: 365,
    offsetHi: 90,
  },
  {
    key: "monitor",
    label: "Monitor",
    detail: "More than 12 months before the notice or expiry date",
    color: T.leaseActionBuckets.monitor.foreground,
    offsetLo: Infinity,
    offsetHi: 365,
  },
];
